import { Outlet } from 'react-router-dom';
import GuestGuard from 'utils/route-guard/GuestGuard';

export default function AuthLayout() {
    return (
        <GuestGuard>
            <Outlet />
        </GuestGuard>
    );
}
